/** @jsx jsx */
import { Fragment, useContext, useState } from 'react';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import { field, useForm, useSubmit, validate } from '@balance-web/forms';
import { jsx } from '@balance-web/core';
import { Field } from '@balance-web/field';
import { Flex } from '@balance-web/flex';
import { TextInput } from '@balance-web/text-input';
import { Button } from '@balance-web/button';
import { Box } from '@balance-web/box';
import { Radio } from '@balance-web/radio';
import { Stack } from '@balance-web/stack';
import { Checkbox } from '@balance-web/checkbox';

import { TextField } from '../generic/TextField';
import { IdContext } from '../../context';

export const MFAPinForm: NextPage<{
  mfaPin: string;
  token: string;
  setErrorMessage?: any;
}> = ({ mfaPin, token, setErrorMessage }) => {
  const { redirectURL, tenancy: TENANCY } = useContext(IdContext);
  let [ownPin, setOwnPin] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const router = useRouter();
  let mfaPinForm = field.object({
    newPin: field.text({
      validate: validate((value) => {
        if (ownPin && !value.length) return validate.error('Enter the pin');
        return value;
      }),
    }),
  });

  const [confirmed, setConfirmed] = useState<boolean>(false);
  const Confirm = (e: any) => setConfirmed(e.target.checked);

  let form = useForm(mfaPinForm);
  const handleChange = (e: any) => setOwnPin(e.target.value === 'ownPin');
  const submit = useSubmit(form, async (value: any) => {
    if (!confirmed || (ownPin && !value.newPin)) return;
    try {
      setLoading(true);
      /* const newPin = value.newPin || mfaPin;
       await updateMFAPin(mfaPin.toString(), newPin.toString(), token); */
      TENANCY === 'APS'
        ? router.push('/')
        : window.location.replace(`${redirectURL}/#/user/profile`);
    } catch (err) {
      setErrorMessage(err.message);
    }
  });
  return (
    <Fragment>
      <form
        id="confirm-pin-form"
        onChange={() => setErrorMessage('')}
        onSubmit={submit}
      >
        <Flex
          direction="column"
          gap="medium"
          alignItems="center"
          padding="xlarge"
        >
          <Box
            paddingX="large"
            paddingY="medium"
            borderRadius="small"
            width={400}
          >
            <Stack gap="medium">
              <Radio
                name="demo-radios"
                value={'generatedPin'}
                checked={!ownPin}
                onChange={handleChange}
              >
                Use Generated secure PIN (recommended)
              </Radio>
              <Radio
                name="demo-radios"
                value={'ownPin'}
                checked={!!ownPin}
                onChange={handleChange}
              >
                Create my own Recovery PIN
              </Radio>
            </Stack>
          </Box>
          <Box
            paddingX="medium"
            paddingY="medium"
            borderRadius="small"
            width={400}
          >
            {ownPin ? (
              <TextField
                type="text"
                label="RecoveryPIN"
                labelVisible={false}
                placeholder="Enter your Recovery PIN"
                {...form.fields.newPin.props}
              />
            ) : (
              <Field label="RecoveryPIN" labelVisible={false}>
                <TextInput
                  type="text"
                  disabled
                  onChange={(e) => e.preventDefault()}
                  value={`Your Recovery PIN: ${mfaPin}`}
                />
              </Field>
            )}
          </Box>
          <Box
            paddingX="medium"
            paddingY="medium"
            borderRadius="small"
            width={400}
          >
            <Checkbox checked={confirmed} onChange={Confirm}>
              I've recorded and securely stored my Recovery PIN
            </Checkbox>
            <Box marginTop="medium">
              <Button
                id="login"
                disabled={form.validity !== 'valid' || !confirmed}
                type="submit"
                size="medium"
                loading={loading}
                block
                label="Submit"
              />
            </Box>
          </Box>
        </Flex>
      </form>
    </Fragment>
  );
};
